var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.714,
    height: 8,
    viewBox: "0 0 13.714 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M6.571,11.429a.571.571,0,0,1,.571-.571h3.429a.571.571,0,0,1,0,1.143H7.143A.571.571,0,0,1,6.571,11.429ZM4.286,8a.571.571,0,0,1,.571-.571h8a.571.571,0,1,1,0,1.143h-8A.571.571,0,0,1,4.286,8ZM2,4.571A.571.571,0,0,1,2.571,4H15.143a.571.571,0,0,1,0,1.143H2.571A.571.571,0,0,1,2,4.571Z",
    transform: "translate(-2 -4)",
    fill: "#2e567a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d4e16ea9b3ccff0e34c395c9e09cb502.svg";
export { ForwardRef as ReactComponent };